import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Attachments\n          ")
], -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("p", null, "This offer will be rejected by the approvers or HR Admin if you do not attach the appropriate verified documentation.", -1);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("p", null, "This must be in the required format to ensure we maintain the standards required for Legal and Audit\n            purposes. We also need to adhere to British Standards to enable EQUANS to bid on all new business.\n        ", -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "New starters to the business:", -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("p", null, "Recruitment is a legal process so all relevant documentation must be completed and correct. If not a\n            contract cannot be issued and the new starter will not be paid.\n        ", -1);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("p", null, "I confirm that the following attachments have been included:", -1);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("ul", null, [
    /*#__PURE__*/ _createElementVNode("li", null, "Verified and signed copy of Right to Work in the UK or where applicable proof of an online check via\n                the Home Office online service *"),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("li", null, "Proof of their identity (usually a passport) to support Home Office online check *"),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("li", null, "Candidate's CV *"),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("li", null, "Job Description *")
], -1);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("p", null, "You must have had sight of the original Right to Work document. You should take a copy and write on each\n            copy: “I certify that this is a true copy of the original”, then sign, print your name, note your job title,\n            and date the copy.\n        ", -1);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("p", null, "For EEA Nationals you will need to check proof of their immigration status – either (i) proof of their EEA\n            Settled status – this has to be done via the Home Office online service through the provision of a share\n            code; or (ii) if they meet the new requirements of the immigration system.\n        ", -1);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("p", null, "Please be sure to check the Right to Work Policy to ensure you have provided the correct\n            documentation. The Offer will be rejected if the incorrect documentation is provided.\n        ", -1);
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "Internal appointments: ", -1);
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("p", null, "Right to work documentation will already be on file for the employee, therefore only the new job\n            description is required.", -1);
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("p", null, "Once ready, please scan and attach the copies below.", -1);
const _hoisted_17 = ["innerHTML"];
const _hoisted_18 = ["innerHTML"];
const _hoisted_19 = { class: "px-4 py-3 bg-gray-50 text-right sm:px-6" };
const _hoisted_20 = ["disabled"];
import { ref, toRef } from 'vue';
import { Radio, Textarea } from '@/form';
import FileUploader from '@/components/FileUploader.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'attachmentsForm',
    props: {
        disableForm: { type: Boolean },
        data: {}
    },
    emits: ["update:formData", "submit-form"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const modelValue = toRef(props, 'data');
        const uploading = ref(false);
        const textarea = Textarea('Please advise if any further documentation or qualifications should be requested by the HR Administration Onboarding Team at the Job Offer stage. In addition where the offer requires re-approval please use the box below to add any comments for your approver:', 'documentation', props.disableForm, modelValue.value.candidates.documentation);
        const radio = Radio('Please verify that all attachments have been uploaded: * ', 'attachments', undefined, undefined, props.disableForm, modelValue.value.attachments.attachmentsUploaded);
        const handleUpdateFiles = ({ model }) => {
            modelValue.value.candidates.files = model;
            emit('update:formData', modelValue.value.candidates);
        };
        const submitForm = async () => {
            // Get input elements
            const documentationInput = document.getElementById('documentation');
            const attachmentsYesInput = document.getElementById('radio_button_attachments_yes');
            const attachmentsNoInput = document.getElementById('radio_button_attachments_no');
            // Set formData with input values from fields
            modelValue.value.documentation = documentationInput.value;
            if (attachmentsYesInput.checked)
                modelValue.value.attachments.attachments = attachmentsYesInput.value;
            else if (attachmentsNoInput.checked)
                modelValue.value.attachments.attachments = attachmentsNoInput.value;
            await emit('update:formData', modelValue.value.candidates);
            emit('submit-form', { name: 'attachments', data: props.data.candidates });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createTextVNode(),
                        _hoisted_5,
                        _createTextVNode(),
                        _hoisted_6,
                        _createTextVNode(),
                        _hoisted_7,
                        _createTextVNode(),
                        _hoisted_8,
                        _createTextVNode(),
                        _hoisted_9,
                        _createTextVNode(),
                        _hoisted_10,
                        _createTextVNode(),
                        _hoisted_11,
                        _createTextVNode(),
                        _hoisted_12,
                        _createTextVNode(),
                        _hoisted_13,
                        _createTextVNode(),
                        _hoisted_14,
                        _createTextVNode(),
                        _hoisted_15,
                        _createTextVNode(),
                        _hoisted_16,
                        _createTextVNode(),
                        _createVNode(FileUploader, {
                            name: "attachments-form",
                            disabled: _ctx.disableForm,
                            files: _ctx.data.candidates.files,
                            "document-short-id": _ctx.data.shortId,
                            uploading: uploading.value,
                            onUpdateFiles: handleUpdateFiles,
                            onFileUploading: _cache[0] || (_cache[0] = ($event) => (uploading.value = $event))
                        }, null, 8, ["disabled", "files", "document-short-id", "uploading"]),
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(radio) }, null, 8, _hoisted_17),
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(textarea) }, null, 8, _hoisted_18)
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("button", {
                            class: "mr-2 bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                            onClick: _withModifiers(submitForm, ["prevent"])
                        }, "\n          Reset Form\n        "),
                        _createTextVNode(),
                        _createElementVNode("button", {
                            type: "submit",
                            class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                            disabled: uploading.value
                        }, "\n          Next\n        ", 8, _hoisted_20)
                    ])
                ])
            ]));
        };
    }
});
